import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

// Shows a modal injected by a turbo stream, and takes it back out of the DOM
// once it closes so a second request does not stack a duplicate id.
//
// Usage:
//   <div data-controller="auto-modal">
//     <div class="modal">…
//       <button data-action="click->auto-modal#hide">Cancel</button>
export default class extends Controller {
  connect() {
    const el = this.element.querySelector('.modal');
    if (!el) return;

    this.#removeStaleModal(el.id);

    this.modal = new bootstrap.Modal(el);
    this.modal.show();

    el.addEventListener('hidden.bs.modal', () => {
      this.modal.dispose();
      this.modal = null;
      this.element.remove();
    }, {once: true});
  }

  disconnect() {
    this.modal?.dispose();
    this.modal = null;
  }

  hide() {
    this.modal?.hide();
  }

  #removeStaleModal(id) {
    if (!id) return;

    document.querySelectorAll(`.modal#${CSS.escape(id)}`).forEach((modal) => {
      if (this.element.contains(modal)) return;

      bootstrap.Modal.getInstance(modal)?.dispose();
      modal.closest('[data-controller~="auto-modal"]')?.remove();
      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
    });
  }
}
